import { Card, H1, HTMLTable, Icon } from "@blueprintjs/core";
import * as format from "date-fns/format";
import * as React from "react";
import styled from "react-emotion";
import { firestore } from "../firebase";
import "../styles/scheduledreports.css";

interface ScheduledReportsState {
  businessNamesKey: any;
  loading: boolean;
  proMembers: any[];
}

interface ImageCardProps {
  height: number;
  src: string;
  width: number;
}

const ImageCard = styled(Card)`
  background-image: url(${(props: ImageCardProps) => props.src});
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.height}px`};
  background-size: contain;
`;

class ProMembers extends React.Component<{}, ScheduledReportsState> {
  public state: ScheduledReportsState = {
    businessNamesKey: {},
    loading: false,
    proMembers: [],
  };

  public async componentDidMount() {
    await this.getMembers();
  }

  public render() {
    const { proMembers, loading } = this.state;
    if (loading) {
      return (
        <div>
          <br />
          <br />
          <br />
          <H1>
            Loading... <Icon className="icon-spin" icon="refresh" iconSize={40} />
          </H1>
        </div>
      );
    }
    return (
      <div style={{ margin: "0 auto" }}>
        <HTMLTable striped={true}>
          <thead>
            <tr>
              <th>Image</th>
              <th>Mobile</th>
              <th>Business</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            {proMembers.map((member, index) => (
              <tr key={index}>
                <td>{member.mugshot ? <ImageCard elevation={2} src={member.mugshot} width={50} height={50} /> : ""}</td>
                <td>{member.mobile}</td>
                <td>{member.businessName}</td>
                <td>{format(member.start_date, "M/D/YY")}</td>
                <td>{format(member.end_date, "M/D/YY")}</td>
                <td>{}</td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </div>
    );
  }

  private async getBusinessName(businessId: string) {
    const query = await firestore.doc("businesses/" + businessId).get();
    const data = query.data();
    if (data) {
      // console.log(data.path);
      return data.path;
    }
    return "";
  }

  private async getMembers() {
    this.setState({ loading: true });
    const query = await firestore.collection("membership").get();
    const proMembers: object[] = [];
    for (const doc of query.docs) {
      const members = doc.data();
      members.id = doc.id;
      // console.log(members);

      const businessName = await this.getBusinessName(members.businessId);
      members.businessName = businessName;
      proMembers.push(members);
    }
    this.setState({ proMembers, loading: false });
  }
}

export default ProMembers;



// WEBPACK FOOTER //
// ./src/views/ProMembers.tsx